import { render, staticRenderFns } from "./CompactLocalizedField.vue?vue&type=template&id=befd091e&scoped=true"
import script from "./CompactLocalizedField.vue?vue&type=script&lang=js"
export * from "./CompactLocalizedField.vue?vue&type=script&lang=js"
import style0 from "./CompactLocalizedField.vue?vue&type=style&index=0&id=befd091e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd091e",
  null
  
)

export default component.exports